export const SHAREABLE_ROUTE_PLACEMENT = {
  SIDE_PANEL: 'side_panel',
  MODAL: 'modal',
}

export const SHAREABLE_ROUTE_PLACEMENTS = {
  example_share_availability: SHAREABLE_ROUTE_PLACEMENT.SIDE_PANEL,
  example_book_meeting: SHAREABLE_ROUTE_PLACEMENT.SIDE_PANEL,
  example_send_email: SHAREABLE_ROUTE_PLACEMENT.SIDE_PANEL,
  share_availability: SHAREABLE_ROUTE_PLACEMENT.MODAL,
  book_meeting: SHAREABLE_ROUTE_PLACEMENT.MODAL,
  send_email: SHAREABLE_ROUTE_PLACEMENT.SIDE_PANEL,
}

export const getShareableRoutePlacement = (route) => (
  route?.placement ?? SHAREABLE_ROUTE_PLACEMENT.SIDE_PANEL
)

export const isSidePanelShareable = (shareable, placements = SHAREABLE_ROUTE_PLACEMENTS) => (
  Boolean(shareable) && placements[shareable] === SHAREABLE_ROUTE_PLACEMENT.SIDE_PANEL
)
